import { StyleSheet, Platform } from 'react-native';

import Fonts from '../Themes/Fonts';

export default StyleSheet.create({
  headerContainer: (theme, scrollable) => ({
    borderTopColor: scrollable ? 'transparent' : theme.colors.horizontalLineColor,
    borderTopWidth: 1,
    borderBottomColor: theme.colors.horizontalLineColor,
    borderBottomWidth: 1,
    height: 48,
  }),
  label: (theme, scrollable) => ({
    color: theme.colors.inActiveColorThree,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16,
    paddingVertical: 14,
    paddingHorizontal: scrollable ? (Platform.OS === 'android' ? 20 : 18) : 0,
  }),
  mainView: {
    flexDirection: 'row',
  },
  tabLine: {
    backgroundColor: 'transparent',
    opacity: 0,
    borderTopEndRadius: 1,
    bottom: 0,
    height: 3,
    position: 'absolute',
  },
  activeTabLine: theme => ({
    backgroundColor: theme.colors.activeTabColorTwo,
    borderTopEndRadius: 1,
    bottom: 0,
    height: 3,
    position: 'absolute',
  }),
  tab: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
